import { ApiResponse } from "../../types/admin";

export const ensureArray = <T>(value: T[] | null | undefined): T[] =>
  Array.isArray(value) ? value : [];

const extractArrayFromUnknown = <T>(value: unknown): T[] => {
  if (Array.isArray(value)) {
    return value as T[];
  }

  if (!value || typeof value !== "object") {
    return [];
  }

  const payload = value as Record<string, unknown>;
  const candidateKeys = [
    "$values",
    "items",
    "results",
    "value",
    "contacts",
    "skills",
    "projects",
    "workHistory",
    "workHistories",
    "certificates",
  ];

  for (const key of candidateKeys) {
    const candidate = payload[key];
    if (Array.isArray(candidate)) {
      return candidate as T[];
    }
  }

  const nestedData = payload.data;
  if (nestedData && typeof nestedData === "object") {
    const nested = nestedData as Record<string, unknown>;
    if (Array.isArray(nested.$values)) {
      return nested.$values as T[];
    }

    for (const key of candidateKeys) {
      const candidate = nested[key];
      if (Array.isArray(candidate)) {
        return candidate as T[];
      }
    }
  }

  return [];
};

export const sanitizeArrayResponse = <T>(
  response: ApiResponse<T[] | unknown>,
  sanitizer?: (item: T) => T
): ApiResponse<T[]> => {
  if (!response.success) return response as ApiResponse<T[]>;

  const list = extractArrayFromUnknown<T>(response.data);
  return {
    ...response,
    data: sanitizer ? list.map(sanitizer) : list,
  };
};

export const sanitizeDataResponse = <T>(
  response: ApiResponse<T>,
  sanitizer: (data: T) => T
): ApiResponse<T> => {
  if (!response.success || !response.data) return response;

  return {
    ...response,
    data: sanitizer(response.data),
  };
};
